import { render, staticRenderFns } from "./PrivateShareWarning.vue?vue&type=template&id=55500daa"
import script from "./PrivateShareWarning.vue?vue&type=script&lang=ts"
export * from "./PrivateShareWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports